
<template>
    <el-dialog title="分配用户" :visible.sync="dialogSet" class="setuser">
        <avue-crud :data="list" :option="tableOption" :page="page" @size-change="sizeChange" @current-change="currentChange" @row-click="showRow">
            <template slot-scope="scope" slot="id">
                <el-radio class="radio" v-model="radiouser"  :label="scope.row.id"></el-radio>
            </template>
        </avue-crud>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleEmpty" icon="el-icon-close" size="mini">取 消</el-button>
          <el-button size="mini" icon="el-icon-success" type="primary" @click="creates">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
 import {allotObj,addsObj} from '@/api/admin/role'
 import {fetchList} from '@/api/admin/user'
import {fetchTree} from '@/api/admin/dept'
import {formatSelectTree,dealElement} from '@/util/util'
import waves from '@/directive/waves/index.js' // 水波纹指令
import {objKeySort} from '@/util/ajaxsign'
export default {
    name: 'table_user',
    directives: {
        waves
    },
    data() {
        return {
            dialogSet : false,
            list : [],
            roleId : '',
            radiouser : '',
            listQuery: {
                current: 1,
                size: 10,
                name : ''
            },
            page: {
                pageSizes: [10, 20, 50, 100],
                currentPage: 1,
                total: 0,
                pageSize: 10
            },
             tableOption : {
                  addBtn : false,
                  refreshBtn : false,
                  columnBtn : true,
                  editBtn : true,
                  delBtn : true,
                  menu : false,
                  page:true,
                  border : true,
                  align:'center',
                  menuAlign:'center',
                  height : window.innerHeight - 290,
                  index:false,
                  column:[
                    {
                      label:'',
                      prop:'id',
                      width:40,
                      solt:true
                    },
                    {
                      label:'登录账号',
                      prop:'account'
                    },{
                      label:'用户姓名',
                      prop:'name'
                    },{
                      label:'所属部门',
                      prop:'deptName'
                    },{
                      label:'创建时间',
                      prop:'createtime',
                      overHidden : true,
                      type: 'date',
                      format: 'yyyy-MM-dd HH:mm:ss',
                      valueFormat: 'yyyy-MM-dd HH:mm:ss'
                    }
                  ]
                },
        }
    },
    created() {},
    methods: {
        //展示弹出层
        dialog(data){
            this.dialogSet = true;
            this.roleId = data;
            this.radiouser = undefined;
            this.allotObj();
        },

        //获取用户数据信息
        allotObj(data){
            fetchList(objKeySort(this.listQuery)).then(response => {
                this.list = response.data.data;
                this.page.total = response.data.data.length;
                this.listLoading = false;
            })
        },
         //条数
        sizeChange(val) {
            this.listQuery.size = val;
            this.allotObj();
        },
        //页码
        currentChange(val) {
            this.listQuery.current = val;
            this.allotObj();
        },

        //点击列数据
        showRow(row){
            this.radiouser = row.id;
            this.$emit('data',val.pkg);
        },

        handleEmpty(){
            this.dialogSet = false;
        },

        //分配用户
        creates(){
            addsObj(objKeySort({roleId:this.roleId,userIds:this.radiouser})).then(() => {
                this.dialogTableVisible = false
                this.handleEmpty();
                this.$emit('refresh','');
                this.$message({
                    title: '成功',
                    message: '分配成功',
                    type: 'success',
                    duration: 2000
                })
            })
        }

    }
}
</script>
<style lang="scss" scoped>
    .setuser .avue-crud__menu{
        display : none;
    }
    .setuser .el-dialog__body{
        padding : 0 15px;
    }
    .setuser .el-table{
        margin-top : 0;
    }
    .setuser .el-dialog__header{
        margin-bottom : 10px;
    }
    .setuser .el-dialog{
        height : 650px;
    }
</style>
